import React from 'react'
import './FormButton.css'

export default function FormButton({children, isLocked, ...rest}) {
  const buttonStyle = isLocked ? 'formButtonBar submitDisabled' : 'formButtonBar submitEnabled';

  return (
    <div className='formButtonWrapper'>
      <button className={buttonStyle} /*disabled={!isEnabled}*/ {...rest}>{children}</button>
    </div>
  )
}
